import React, { useState, useRef, useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Popper, Paper } from '@material-ui/core'
import styles from './styles'

const TextFieldPopup = ({
  classes,
  children,
  anchorEl,
  open,
  onClose,
  placement = 'bottom-start',
  offset = 8,
  width,
  ...props
}) => {
  const [popupWidth, setPopupWidth] = useState(width || 0)
  const popupRef = useRef(null)

  useEffect(() => {
    if (anchorEl && open) {
      const anchorWidth = anchorEl.offsetWidth
      setPopupWidth(anchorWidth)
    }
  }, [anchorEl, open, width])

  // Custom click-away detection
  useEffect(() => {
    if (!open || !anchorEl) return

    const handleClickOutside = event => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        anchorEl &&
        !anchorEl.contains(event.target)
      ) {
        if (onClose) {
          onClose(event)
        }
      }
    }

    // Add a small delay to prevent immediate triggering
    const timeoutId = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('touchstart', handleClickOutside)
    }, 100)

    return () => {
      clearTimeout(timeoutId)
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)
    }
  }, [open, anchorEl, onClose])

  // Ensure both open state and anchor element are properly set
  // Also add a small check to ensure the anchor element has dimensions
  if (!open || !anchorEl || !anchorEl.offsetWidth) {
    return null
  }

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement={placement}
      className={classes.popper}
      modifiers={{
        offset: {
          offset: [0, offset],
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: 'viewport',
        },
      }}
      {...props}
    >
      <Paper
        ref={popupRef}
        className={classes.popup}
        style={{
          width: popupWidth,
        }}
        elevation={8}
      >
        {children}
      </Paper>
    </Popper>
  )
}

export default withStyles(styles)(TextFieldPopup)
